import { defineMessages } from 'react-intl';

export const aiReviewParamsMessages = defineMessages({
  title: {
    id: 'aiReviewParamsModal.title',
    defaultMessage: 'AI Review Parameters',
  },
  helpTitle: {
    id: 'aiReviewParamsModal.helpTitle',
    defaultMessage: 'Please provide the required AI review parameters.',
  },
  helpText: {
    id: 'aiReviewParamsModal.helpText',
    defaultMessage:
      'The created request will be honored as quickly as possible, depending on the current load (typically within few minutes). The response will be sent to the email address associated with your account as well you will be notified in the application.',
  },
  maxWordsCount: {
    id: 'aiReviewParamsModal.maxWordsCount',
    defaultMessage: 'Maximum desired words count',
  },
  language: {
    id: 'aiReviewParamsModal.language',
    defaultMessage: 'Language',
  },
  createRequest: {
    id: 'aiReviewParamsModal.createRequest',
    defaultMessage: 'Create Request',
  },
});
